<div class="tw:w-full tw:px-[15px] tw:mx-auto">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:pb-6">

    @if (showHeader) {
      <div class="tw:w-full tw:px-[15px]">
        <div class="tw:mt-6">
          <h3 class="tw:pt-4">Generate Learner Access@if (studentName != null && studentName != '') {
            <div class="tw:inline"> - ({{studentName}})</div>
          }</h3>
        </div>
      </div>
    }

    @if (accessChecking) {
      <div class="tw:w-full tw:px-[15px] tw:my-2">
        <label class="font-16">Checking learner details…</label>
      </div>
    }

    <!-- Proactive cue (bug 37289): shown before any button when the learner is missing the details
         (first name / date of birth) that access generation needs — which are managed in Orbit. -->
    @if (!accessChecking && !accessReady) {
      <div class="tw:w-full tw:px-[15px] tw:my-2">
        <div style="border:1px solid #e0a800; background:#fff8e1; border-radius:4px; padding:12px;">
          <div><b>⚠️ This learner isn&rsquo;t ready for portal access yet</b></div>
          @if (accessNotReadyReason) {
            <div class="tw:mt-1">{{ accessNotReadyReason }}</div>
          }
          <div class="tw:mt-2">Learner details are now managed in <b>Orbit</b>. Add the missing information there &mdash; it syncs into Tuition Management automatically &mdash; then this screen will let you generate access.</div>
          @if (orbitLearnerUrl) {
            <div class="tw:mt-3">
              <a [href]="orbitLearnerUrl" target="_blank" rel="noopener" class="btn btn-primary btn-sm">Open in Orbit</a>
            </div>
          }
        </div>
      </div>
    }

    @if (!accessChecking && accessReady) {
      <div class="tw:w-full tw:px-[15px] tw:mb-2">
        <label class="font-16"> Different secure methods to grant your learners safe access to the site:</label>
      </div>

      @if (showWebsiteLink) {
        <div class="tw:w-full tw:px-[15px] tw:my-2">
          <div class="button-container">
            <button type="button" class="btn btn-primary tw:w-full" (click)="generateAccess('link')">Website Link</button>
          </div>
          <div class="description-container tw:pl-2">
            <label class="font-16">Generate a link to grant a learner one-time access</label>
          </div>
        </div>
      }

      <div class="tw:w-full tw:px-[15px] tw:my-2">
          <div class="button-container">
            <button type="button" class="btn btn-primary tw:w-full" (click)="sendSignUpEmail()">Sign up Email</button>
          </div>
          <div class="description-container tw:pl-2">
            <label class="font-16">Send an email to the learner to generate their own login</label>
          </div>
      </div>

      <div class="tw:w-full tw:px-[15px] tw:my-2">
        <div class="button-container">
          <button type="button" class="btn btn-primary tw:w-full" (click)="generateAccess('emoji')">Emoji Key</button>
        </div>
        <div class="description-container tw:pl-2">
          <label class="font-16">Auto generate a 4 Emoji Key</label>
        </div>
      </div>

      <div class="tw:w-full tw:px-[15px] tw:my-2">
        <div class="button-container">
          <button type="button" class="btn btn-primary tw:w-full" (click)="generateAccess('number')">PIN</button>
        </div>
        <div class="description-container tw:pl-2">
          <label class="font-16">Auto generate a 4 Digit PIN</label>
        </div>
      </div>
    }

    @if (generatedSuccessfully) {
      <div class="tw:w-full tw:px-[15px] tw:mt-4">
        <div class="flex-row tw:px-0 tw:mx-0">
          <div class="flex-column tw:px-0 tw:mx-0">
            @if (isLinkResponse) {
              <label class="description-container">Send the link to the learner, who then simply clicks on it, enters their first name and month of birth.</label>
            }
            @if (isPinResponse && !isNumericPin) {
              <label class="description-container">Pass the key to the learner, who then goes to the standard learner login screen, enters their key together with their first name and month of birth.</label>
            }
            @if (isPinResponse && isNumericPin) {
              <label class="description-container">Pass the PIN to the learner, who then goes to the standard learner login screen, enters their PIN together with their first name and month of birth.</label>
            }
          </div>
        </div>
        <div class="flex-row tw:p-0 tw:m-0">
          <div class="flex-column tw:p-0 tw:m-0">
            <label class="url-link tw:mr-2" #linkLabel>{{studentLoginUrl}}</label>
            <button type="button" class="btn btn-primary" style="width: 120px;" (click)="copyLink(linkLabel)">Copy Link</button>
          </div>
        </div>
        @if (isLinkResponse && hasEmailStudentAccessLinkPermission) {
          <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:mb-4 tw:mt-1 tw:pt-4">
            <div class="tw:flex-1 tw:p-0 tw:m-0">
              <label>Email link</label>
              <div class="input-group tw:mb-4">
                <input class="form-control" placeholder="enter email address to send link to" type="text"
                  (keydown.enter)="emailLink()" [(ngModel)]="emailAddress">
                  <div class="input-group-btn">
                    <button class="btn btn-primary" type="button" (click)="emailLink()">Send</button>
                  </div>
                </div>
                @if (showEmailRequiredError) {
                  <div>
                    <label class="tw:text-danger">Email address required</label>
                  </div>
                }
                @if (showEmailInvalidError) {
                  <div>
                    <label class="tw:text-danger">This is an invalid email address</label>
                  </div>
                }
              </div>
            </div>
          }
          @if (isPinResponse) {
            <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:mb-4 tw:mt-4 tw:pt-4">
              <div class="tw:flex-1 tw:p-0 tw:m-0 tw:mr-1 tw:flex tw:justify-start">
                <div #pin1 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                <div #pin2 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                <div #pin3 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                <div #pin4 class="pin-box tw:md:float-left tw:inline-block tw:mx-1" [ngClass]="{'tw:pt-6': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
              </div>
            </div>
          }
        </div>
      }

      @if (showGenerateErrorMessage) {
        <div class="tw:w-full tw:px-[15px] tw:pt-4">
          <label class="tw:text-danger">Only learners with a valid First name and date of birth can be granted access.  Please check these and try again or contact your administrator.</label>
        </div>
      }

    </div>
  </div>
